<p-dialog 
    #dialog 
    class="eda-context" 
    appendTo="body" 
    [(visible)]="inject.display" 
    [modal]="true" 
    [closable]="false"
    [resizable]="false"
    (document:keydown.esc)="inject.hideContextMenu()" 
    (document:click)="onOutsideClick($event, dialog)"
    [header]="inject.header" 
    [style]="inject.style"
    [dismissableMask]="true"
    (onHide)="allowOutsideClose = false;"
>
    <p-panelMenu 
        [model]="inject.contextMenuItems" 
        [style]="{'width':'300px'}">
    </p-panelMenu>

    <div style="text-align: right; margin-top: 1em;">
        <span class="pointer" (click)="inject.hideContextMenu()"> 
            <i class="fa fa-times font-16"></i> 
        </span>
    </div>
</p-dialog>
